var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83398 10.5418C1.83398 11.5544 2.6548 12.3752 3.66732 12.3752C5.1861 12.3752 6.41732 11.144 6.41732 9.62516V5.9585C6.41732 4.43972 5.1861 3.2085 3.66732 3.2085C2.6548 3.2085 1.83398 4.02931 1.83398 5.04183V10.5418Z",
    fill: "#DD5014",
    stroke: "#DD5014",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1882 14.8444L13.944 14.0561C13.744 13.41 13.644 13.087 13.7209 12.8318C13.7832 12.6255 13.9198 12.4476 14.1059 12.3305C14.336 12.1859 14.6841 12.1859 15.3802 12.1859H15.7505C18.1064 12.1859 19.2844 12.1859 19.8408 11.4885C19.9043 11.4088 19.9609 11.324 20.0098 11.2351C20.4378 10.4574 19.9512 9.40965 18.978 7.31415C18.0849 5.39118 17.6383 4.4297 16.8092 3.86378C16.729 3.80899 16.6465 3.7573 16.562 3.70887C15.689 3.2085 14.6075 3.2085 12.4444 3.2085H11.9752C9.35457 3.2085 8.04427 3.2085 7.23014 3.99732C6.41602 4.78613 6.41602 6.05573 6.41602 8.59489V9.48739C6.41602 10.8218 6.41602 11.4889 6.65283 12.0996C6.88964 12.7103 7.34309 13.2124 8.24998 14.2167L12.0004 18.3696C12.0945 18.4738 12.1415 18.5259 12.183 18.562C12.5701 18.8988 13.1674 18.8609 13.5059 18.4781C13.5422 18.437 13.5818 18.3794 13.661 18.2643C13.7849 18.0842 13.8469 17.9941 13.901 17.9048C14.3844 17.106 14.5307 16.157 14.3092 15.2562C14.2845 15.1555 14.2524 15.0517 14.1882 14.8444Z",
    fill: "#DD5014",
    stroke: "#DD5014",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectFilled);
export default __webpack_public_path__ + "static/media/rejectFilled.cacd50121068a663736bc3a82b729504.svg";
export { ForwardRef as ReactComponent };